// Third Party Imports
import React from 'react';
import {get, isEmpty} from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { isUsSite } from '../../../utils/validate';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import AlertBox from '../../Alert/Alert';
import ContinueButtonHolder from '../../ButtonHolder/ContinueButtonHolder';
import './Currency.less';
import currencyActions from '../../../actions/currency';
import appActions from '../../../actions/actions';
import getCurrencySymbol from '../../utils/currencyUtil';

function mapStateToProps(state) {
    return {
        publicUuid: state.app.publicUuid,
        siteName: state.system.siteName,
        translations: state.app.translations,
        errorKey: state.currency.errorKey,
        currency: state.currency.currency || '',
        brandName: state.system.brandName,
        currencyChangeError: state.currency.currencyChangeError,
        enableContinueButton: state.currency.enableContinueButton,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        language: get(state, 'landingPage.language', 'en_US'),
        supportedCurrencies: get(state, 'currency.supportedCurrencies', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        currencyActions: bindActionCreators(currencyActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Currency extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const {language} = this.props;
        this.props.appActions.enableLoadOverLay(true);
        this.props.currencyActions.getSupportedCurrencies(language);
    }

    componentDidMount() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Currency Page');
    }

    getListItems = (currencyList) => {
        const {translations} = this.props;
        const items = currencyList && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }

    handleCurrencyChange = (e) => {
        const value = e.target.value;
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Currency selected',
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.props.currencyActions.setCurrency(value);
        if (value.trim() === '') {
            this.props.currencyActions.setCurrencyChangeError('ipmob.input.field.required');
            this.props.currencyActions.enableContinueButton(false);
        } else {
            this.props.currencyActions.setCurrencyChangeError(null);
            this.props.currencyActions.enableContinueButton(true);
        }
    }

    handleContinueClick = () => {
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});

        if (!this.props.currency) {
            const currencyList = this.getCurrencyList();

            if (currencyList && currencyList.length === 1) {
                this.props.currencyActions.setCurrency(currencyList[0]);
            }
        }

        this.props.appActions.changeAppState('MASTER_BRAND')
    }

    getHeading = (currencyList) => {
        const {translations} = this.props;
        return currencyList && currencyList.length === 1 ? translations['ipmob.currency.heading.2'] : translations['ipmob.currency.heading.1'];
    }

    renderCurrencyComponent = (currencyList) => {
        const {currency, translations, brandName, currencyChangeError} = this.props;

        return (currencyList && currencyList.length === 1)
            ? <div>
                <div className="currency-brand"><b>{`${brandName} ${translations['ipmob.currency.brand.currency']}:`}</b></div>
                <div className="currency-desc">{`${getCurrencySymbol(currencyList[0])} (${translations[`ipmob.currency.${currencyList[0]}`] ? translations[`ipmob.currency.${currencyList[0]}`] : currencyList[0]})`}</div>
            </div>
            : (
                <FormSelect
                    id="currency"
                    className="currency-select"
                    name={translations['ipmob.currency']}
                    items={this.getListItems(currencyList)}
                    value={currency}
                    onChange={this.handleCurrencyChange}
                    label={translations['ipmob.currency']}
                    errorMsg={translations[currencyChangeError]}
                />
            );
    }

    handleAlertDismiss = () => {
        this.props.currencyActions.currencyServiceError('');
    }

    getCurrencyList = () => {
        const {supportedCurrencies} = this.props;
        let currencyList = [];

        if (!isEmpty(supportedCurrencies)) {
            supportedCurrencies.forEach((item) => {
                currencyList = currencyList.concat(item.currency);
            });
        }

        return currencyList;
    }

    handleBackButtonClick = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });
        this.props.appActions.changeAppState('BASIC_INFORMATION');
    }

    render() {
        const {
            translations,
            errorKey,
            enableContinueButton,
        } = this.props;
        const currencyList = this.getCurrencyList();
        const noteLabel = translations['ipmob.currency.note_label'];

        return (
            <div className="currency">
                <div className="currency-container">
                    {
                        (errorKey)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={errorKey}
                                    translations={translations}
                                    handleAlertDismiss={this.handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="currency-wrapper">
                        <div className="currency-content-col">
                            <h2 className="currency-heading"> {this.getHeading(currencyList)} </h2>
                            <h3 className="currency-sub-heading"> {translations['ipmob.currency.heading.4']} </h3>
                            <div className="currency-desc"> {translations['ipmob.currency.sub.heading']} </div>
                            {errorKey ? null : this.renderCurrencyComponent(currencyList)}
                        </div>
                    </div>
                    <div className="currency-wrapper">
                        {
                            (isUsSite)
                                ?
                                <div className="currency-content-col">
                                    <a href="/p/onboard">{noteLabel}</a>
                                </div>
                                : null
                        }
                    </div>
                    <ContinueButtonHolder
                        translations={translations}
                        enableContinueButton={currencyList.length === 1 || enableContinueButton}
                        handleContinueButtonClick={this.handleContinueClick}
                        continueButtonId={'currencyPageContnBtn'}
                        enableBackButton
                        handleBackButtonClick={this.handleBackButtonClick}
                    />
                </div>
            </div>
        )
    }
}
